module.exports = __webpack_public_path__ + "img/icon_shouye_jihuo.eb584e8a.png";